// Shared Lightweight Charts display settings.
export const PRICE_LINE_WIDTH = 2;
export const PRICE_LINE_COLOR_LIGHT = "#6aa0f8";
export const PRICE_LINE_COLOR_DARK = "#7DA0FF";
